module.exports = __webpack_public_path__ + "img/6.3338b8c.webp";